import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSuccessFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10 18C7.125 18 4.5 16.5 3.0625 14C1.625 11.5312 1.625 8.5 3.0625 6C4.5 3.53125 7.125 2 10 2C12.8438 2 15.4688 3.53125 16.9062 6C18.3438 8.5 18.3438 11.5312 16.9063 14C15.4688 16.5 12.8438 18 10 18ZM13.5313 8.53125H13.5C13.8125 8.25 13.8125 7.78125 13.5 7.46875C13.2188 7.1875 12.75 7.1875 12.4688 7.46875L9 10.9687L7.53125 9.5C7.21875 9.1875 6.75 9.1875 6.46875 9.5C6.15625 9.78125 6.15625 10.25 6.46875 10.5312L8.46875 12.5312C8.75 12.8437 9.21875 12.8437 9.53125 12.5312L13.5313 8.53125Z"
	})
});
const ForwardRef = forwardRef(SvgSuccessFilled);
export default ForwardRef;
